import qs from 'qs';
import axios from 'axios';

export default {
  modifyIntegration: ({ commit }, payload) => {
    axios({
      url: '/engine/integrations/' + payload.id,
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then(response => {
        commit('integrations/REPLACE_INTEGRATION', response.data, { root: true });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  refreshIntegration: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/integrations/' + payload.id + '/refresh',
      method: 'POST'
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
        commit('ui/HIDE_OVERLAY', true, { root: true });
      });
  },
  changeIntegrationEnableState: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/integrations/' + payload.id + '/enabled',
      method: 'PUT',
      data: qs.stringify(payload)
    })
      .then(response => {
        commit('integrations/REPLACE_INTEGRATION', response.data, { root: true });
        commit('ui/HIDE_OVERLAY', true, { root: true });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
        commit('ui/HIDE_OVERLAY', true, { root: true });
      });
  },
  syncDevices: ({ commit }, payload) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/integrations/' + payload.id + '/sync',
      method: 'POST',
      data: qs.stringify(payload)
    })
      .then(response => {
        commit('integrations/REPLACE_INTEGRATION', response.data, { root: true });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  queryLocation: ({ commit }, { payload, success } = {}) => {
    commit('SET_QUERY_LOCATION_RESPONSE', null);

    axios({
      url: '/engine/integrations/location/query',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload)
    })
      .then((response) => {
        commit('SET_QUERY_LOCATION_RESPONSE', response.data);
        if (typeof success === "function") {
          success(response.data);
        }
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  }
};